import { createAction } from 'redux-actions';
import * as types from './constants';

export const fetchInstalledAtInfo = createAction(types.INSTALLED_AT_INFO_REQUEST);
export const installedAtInfoSuccess = createAction(types.INSTALLED_AT_INFO_SUCCESS);
export const installedAtInfoFailure = createAction(types.INSTALLED_AT_INFO_FAILURE);

export const saveInstalledAtInfoRequest = createAction(types.INSTALLED_AT_INFO_SAVE_REQUEST);
export const saveInstalledAtInfoSuccess = createAction(types.INSTALLED_AT_INFO_SAVE_SUCCESS);
export const saveInstalledAtInfoFailure = createAction(types.INSTALLED_AT_INFO_SAVE_FAILURE);

export const verifyInstalledAtInfoRequest = createAction(types.VERIFY_INSTALLED_AT_INFO_REQUEST);
export const verifyInstalledAtInfoSuccess = createAction(types.VERIFY_INSTALLED_AT_INFO_SUCCESS);
export const verifyInstalledAtInfoFailure = createAction(types.VERIFY_INSTALLED_AT_INFO_FAILURE);
